function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { memo } from 'react';
import Svg, { Defs, Path, G, Mask, Use } from 'react-native-svg';
const HomeImprovement = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: "60px",
  height: "64.0563696px",
  viewBox: "0 0 60 64.0563696",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement(G, {
  transform: "translate(-655 -498.874) translate(585 460.84) translate(70 38.033)",
  stroke: "#222A34",
  strokeWidth: 1.85,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M41.7995587 14.9996421L41.7995587 16.6350825 41.7995587 28.940147"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M27.0677427 40.3124283L26.9183519 40.3124283 19.1244594 40.3124283 9.09912622 40.3124283 4.24594437 40.3124283 4.24594437 14.9996557"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M46.061 14.745c.001.406-.174.753-.441.99-.382.34-.954.452-1.469.187L23.02 5.032 8.025 12.885 1.92 16.08c-.873.456-1.916-.18-1.917-1.17L0 12.852c0-.493.272-.945.706-1.173l7.319-3.831 6.679-3.497L23.013 0l8.442 4.35 13.89 7.157a1.324 1.324 0 01.714 1.173l.002 2.065zM31.113 20.253v8.687h-.834a3.22 3.22 0 00-3.211 3.23v.658H18.61c-2.03 0-3.677-1.655-3.677-3.698v-8.877c0-2.043 1.646-3.7 3.677-3.7h8.827c2.03 0 3.676 1.657 3.676 3.7z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M27.896 24.691c0 2.708-2.182 4.902-4.873 4.902-2.691 0-4.873-2.194-4.873-4.902 0-2.707 2.182-4.902 4.873-4.902 2.691 0 4.873 2.195 4.873 4.902z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M23.0230611 19.7892081L23.0230611 29.5933213"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M57.92 32.17V42.7a3.22 3.22 0 01-3.21 3.23H30.278a3.217 3.217 0 01-3.211-3.23V32.17a3.22 3.22 0 013.211-3.23h24.43a3.22 3.22 0 013.211 3.23z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M58.206 37.435h0A1.8 1.8 0 0160 39.239v7.758a3.06 3.06 0 01-3.05 3.068H44.51c-1.847 0-3.344 1.506-3.344 3.364v1.869"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M42.852 64.056H39.48c-.572 0-1.04-.47-1.04-1.045v-6.668c0-.575.468-1.045 1.04-1.045h3.372c.572 0 1.04.47 1.04 1.045v6.668c0 .575-.468 1.045-1.04 1.045z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const Other = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: "60px",
  height: "64px",
  viewBox: "0 0 60 64",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement(G, {
  fill: "#222A34",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement(Path, {
  d: "M42.126 18.635c-3.518-3.202-8.128-4.835-13.005-4.615-8.998.419-16.331 7.487-16.693 16.091-.207 4.91 1.833 9.644 5.597 12.986 2.643 2.348 4.159 5.787 4.159 9.436v5.804c0 2.494 1.4 3.472 2.692 3.579v.161c0 1.06.903 1.923 2.012 1.923h6.223c1.11 0 2.012-.863 2.012-1.923v-.152c1.597-.022 2.888-1.27 2.888-2.801v-6.776c0-3.587 1.504-7.014 4.124-9.399 3.515-3.2 5.451-7.513 5.451-12.144 0-4.644-1.939-8.966-5.459-12.17zm-6.2 35.541v1.992H24.267v-1.992h11.66zm-.848 5.757h-.997c-.576 0-1.042.446-1.042.996l.072 1.079-6.152.068V60.93c0-.55-.466-.996-1.042-.996h-.802c-.765 0-.848-1.116-.848-1.596v-.177h11.66v.963c0 .447-.38.81-.848.81zm5.62-18.426c-2.992 2.722-4.717 6.607-4.763 10.678H24.249c-.095-4.07-1.826-7.9-4.807-10.547-3.318-2.946-5.115-7.118-4.933-11.446.32-7.584 6.782-13.814 14.713-14.182 4.292-.202 8.365 1.244 11.467 4.068 3.103 2.824 4.812 6.634 4.812 10.727 0 4.08-1.706 7.882-4.804 10.703v-.001z",
  transform: "translate(-881 -500) translate(811 460) translate(70 40)"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M28.454 18c-4.643 0-8.891 2.844-10.821 7.245a.543.543 0 00.252.706.497.497 0 00.212.049.51.51 0 00.466-.311c1.765-4.023 5.647-6.623 9.891-6.623a.522.522 0 00.512-.533.522.522 0 00-.512-.533zM18.254 27.008c-.245-.048-.472.137-.513.415a13.809 13.809 0 00-.155 2.065c0 .283.198.512.443.512s.443-.229.443-.512c0-.635.048-1.27.142-1.888.042-.278-.12-.543-.36-.592zM58.966 28h-7.242c-.572 0-1.034.448-1.034 1s.462 1 1.034 1h7.242c.571 0 1.034-.448 1.034-1s-.463-1-1.034-1zM9.31 29c0-.552-.463-1-1.034-1H1.034C.463 28 0 28.448 0 29s.463 1 1.034 1h7.242c.571 0 1.034-.448 1.034-1zM30 9c.571 0 1.034-.448 1.034-1V1c0-.552-.463-1-1.034-1s-1.034.448-1.034 1v7c0 .552.463 1 1.034 1zM46.262 43.295a1.067 1.067 0 00-1.474 0 .983.983 0 000 1.424l5.157 4.986c.204.197.47.295.737.295s.533-.098.737-.295a.983.983 0 000-1.424l-5.157-4.986zM13.739 14.705c.203.197.47.295.736.295.267 0 .533-.098.737-.295a.983.983 0 000-1.424l-5.157-4.986a1.067 1.067 0 00-1.474 0 .983.983 0 000 1.424l5.158 4.986zM13.739 43.295L8.58 48.281a.983.983 0 000 1.424c.204.197.47.295.737.295.266 0 .533-.098.737-.295l5.157-4.986a.983.983 0 000-1.424 1.067 1.067 0 00-1.473 0zM45.525 15c.266 0 .533-.098.737-.295l5.157-4.986a.983.983 0 000-1.424 1.067 1.067 0 00-1.474 0l-5.157 4.986a.983.983 0 000 1.424c.204.197.47.295.737.295z",
  transform: "translate(-881 -500) translate(811 460) translate(70 40)"
})));
const DebtConsolidation = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: "60px",
  height: "64.0563696px",
  viewBox: "0 0 60 64.0563696",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
  id: "a",
  d: "M0 64.0563696L60 64.0563696 60 0 0 0z"
})), /*#__PURE__*/React.createElement(G, {
  transform: "translate(-427 -499.875) translate(359 460.84) translate(68 39.034)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.55,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.78441854 63.4155421L49.9747627 63.4155421 49.9747627 38.0649723 9.78441854 38.0649723z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.78444286 38.0650633L3.80483948 57.8611881 9.78444286 52.8335968z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M49.9748113 38.0650633L55.9544147 57.8611881 49.9748113 52.8335968z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M32.836 46.057a.677.677 0 01-.935.048 2.509 2.509 0 00-1.661-.594c-.242 0-.487.035-.735.105-.248.07-.473.184-.675.34a1.842 1.842 0 00-.492.584 1.72 1.72 0 00-.19.834c0 .313.058.575.174.786.116.21.273.388.47.534.197.146.43.27.698.373.267.103.553.208.856.316.364.119.733.254 1.107.405.374.151.713.35 1.016.6.303.248.55.558.743.93.192.373.288.846.288 1.418 0 .594-.104 1.11-.311 1.547-.207.437-.483.8-.826 1.085-.344.287-.74.5-1.19.64-.45.14-.913.21-1.388.21-.677 0-1.331-.14-1.963-.42a3.961 3.961 0 01-.976-.614c-.345-.295-.345-.857-.007-1.162l.048-.044a.673.673 0 01.938.024c.178.178.382.334.611.467a2.682 2.682 0 002.138.26c.252-.076.482-.195.69-.357.207-.162.376-.364.507-.607.132-.243.198-.537.198-.883s-.069-.634-.205-.867a1.873 1.873 0 00-.554-.591 3.567 3.567 0 00-.81-.413c-.309-.114-.635-.23-.978-.348a8.055 8.055 0 01-1.016-.397 3.49 3.49 0 01-.895-.6 2.755 2.755 0 01-.636-.899c-.162-.356-.243-.799-.243-1.328 0-.572.108-1.064.326-1.474.217-.41.5-.75.849-1.02s.743-.468 1.182-.592c.44-.124.882-.186 1.327-.186a4.36 4.36 0 011.759.356c.239.104.458.224.656.36.382.26.43.837.105 1.174z",
  fill: "#222A34"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M32.836 46.057a.677.677 0 01-.935.048 2.509 2.509 0 00-1.661-.594c-.242 0-.487.035-.735.105-.248.07-.473.184-.675.34a1.842 1.842 0 00-.492.584 1.72 1.72 0 00-.19.834c0 .313.058.575.174.786.116.21.273.388.47.534.197.146.43.27.698.373.267.103.553.208.856.316.364.119.733.254 1.107.405.374.151.713.35 1.016.6.303.248.55.558.743.93.192.373.288.846.288 1.418 0 .594-.104 1.11-.311 1.547-.207.437-.483.8-.826 1.085-.344.287-.74.5-1.19.64-.45.14-.913.21-1.388.21-.677 0-1.331-.14-1.963-.42a3.961 3.961 0 01-.976-.614c-.345-.295-.345-.857-.007-1.162l.048-.044a.673.673 0 01.938.024c.178.178.382.334.611.467a2.682 2.682 0 002.138.26c.252-.076.482-.195.69-.357.207-.162.376-.364.507-.607.132-.243.198-.537.198-.883s-.069-.634-.205-.867a1.873 1.873 0 00-.554-.591 3.567 3.567 0 00-.81-.413c-.309-.114-.635-.23-.978-.348a8.055 8.055 0 01-1.016-.397 3.49 3.49 0 01-.895-.6 2.755 2.755 0 01-.636-.899c-.162-.356-.243-.799-.243-1.328 0-.572.108-1.064.326-1.474.217-.41.5-.75.849-1.02s.743-.468 1.182-.592c.44-.124.882-.186 1.327-.186a4.36 4.36 0 011.759.356c.239.104.458.224.656.36.382.26.43.837.105 1.174h0z",
  stroke: "#222A34",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.76,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M30.0429825 44.1665443L30.0429825 42.7381657"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.76,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M30.0657995 57.6240391L30.0657995 56.1956604"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M41.209 7.572V19.27h6.472v-5.591h3.391v5.591h6.474V7.572l1.024.426a.54.54 0 00.638-.086.618.618 0 00.192-.457V6.5a.63.63 0 00-.192-.454.578.578 0 00-.12-.088l-6.042-3.307-3.673-2.01-3.615 2.01-2.905 1.616-3.184 1.77a.617.617 0 00-.308.542l.002.952c0 .458.454.751.834.54l1.012-.499z",
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement(Mask, {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)",
  d: "M17.7896971 15.7538821L22.2151679 15.7538821 22.2151679 13.0517759 17.7896971 13.0517759z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)",
  d: "M5.18314998 15.7538171L6.8690031 15.7538171"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)",
  d: "M9.08176284 15.7538171L14.2447716 15.7538171"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M25.309 7.794v9.826c0 .911-.691 1.65-1.544 1.65H4.725c-.852 0-1.544-.739-1.544-1.65V7.794c0-.91.692-1.648 1.543-1.648h19.041c.853 0 1.544.739 1.544 1.648z",
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M22.727 2.289v3.857H4.724c-.851 0-1.543.739-1.543 1.648v5.97H2.142C1.29 13.764.6 13.026.6 12.116V2.289c0-.91.69-1.648 1.542-1.648h19.042c.852 0 1.543.738 1.543 1.648z",
  stroke: "#222A34",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#222A34",
  mask: "url(#b)",
  d: "M1.04075067 4.86202371L23.16774 4.86202371 23.16774 2.6622088 1.04075067 2.6622088z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)",
  d: "M19.9800899 22.4989848L24.2299333 27.04001 26.3180024 24.8090049 26.3180024 33.2183877 26.3127725 33.223976 18.4426201 33.223976 20.5306892 30.9928409 16.2808458 26.4516859 12.5986293 22.517309"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#222A34",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)",
  d: "M39.7322533 22.4989848L35.4824099 27.04001 33.3943408 24.8090049 33.3943408 33.2183877 33.3995707 33.223976 41.2697231 33.223976 39.181654 30.9928409 43.4314974 26.4516859 47.1137139 22.517309"
})));
const DebtConsolidationIcon = /*#__PURE__*/memo(DebtConsolidation);
const HomeImprovementIcon = /*#__PURE__*/memo(HomeImprovement);
const OtherIcon = /*#__PURE__*/memo(Other);
export { DebtConsolidationIcon, HomeImprovementIcon, OtherIcon };
//# sourceMappingURL=index.js.map